import { render, staticRenderFns } from "./PointRulesSetting.vue?vue&type=template&id=751c6292&scoped=true&"
import script from "./PointRulesSetting.vue?vue&type=script&lang=js&"
export * from "./PointRulesSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751c6292",
  null
  
)

export default component.exports